export enum ActiveLinkType {
  ProductSearch = 'productSearch',
  ItemSelection = 'itemSelection',
  Specifications = 'specifications',
  ReviewOrder = 'reviewOrder',
  ProductName = 'crispgrna',
  ProductType = 'crisprgrna',
  Geneknockout = 'geneknockout',
}

export enum SpecificationMessages {
  RNA = 'RNA',
  DNA = 'DNA',
  VIRUS = 'VIRUS',
  SPCAS9 = 'SPCAS9',
  FNCAS9 = 'FNCAS9',
  CRISPRSpecies = 'CRISPR Species',
  structure = 'Structure',
  Two = '2',
  Three = '3',
  Five = '5',
  ScaleTwo = 'two',
  ScaleThree = 'three',
  ScaleFive = 'five',
  ScaleofSynthesis = 'Scale of Synthesis',
  Yes = 'Y',
  No = 'N',
  Modified = 'Modified',
  DESALT = 'DESALT',
  HPLC = 'HPLC',
  STANDARD = 'STANDARD',
  PUREDIT = 'PUREDIT',
  STANDARDVal = 'Standard',
  PUREDITVal = 'PURedit\u2122',
  Puredit = 'Puredit',
  Purification = 'purification',
  CRRNA = 'CRRNA',
  SYGRNA = 'SYGRNA',
  powerof6 = 'powerof6',
  powerof7 = 'powerof7',
  powerof8 = 'powerof8',
  powerof9 = 'powerof9',
  TenPSix = '10^6',
  TenPSeven = '10^7',
  TenPEight = '10^8',
  TenPNine = '10^9',
  pointTwo = 'pointTwo',
  pointOne = 'pointOne',
  volOne = 'volOne',
  volTwo = 'volTwo',
  volFive = 'volFive',
  dotTwo = '0.2',
  dotOne = '0.1',
  oneVol = '1',
  twoVol = '2',
  fiveVol = '5',
  ten = '10',
  TwentyFive = '25',
  hundred = '100',
  oneRom = 'one',
  tenRom = 'ten',
  twentyFiveRom = 'twentyFive',
  hundredRom = 'hundred',
  dry = 'DRY',
  lv01 = 'LV01',
  LV02 = 'LV02',
  LV03 = 'LV03',
  LV04 = 'LV04',
  LV05 = 'LV05',
  LV08 = 'LV08',
  LV13 = 'LV13',
  LV14 = 'LV14',
  LV15 = 'LV15',
  LV16 = 'LV16',
  LV17 = 'LV17',
  p01 = 'p01',
  p02 = 'p02',
  p03 = 'p03',
  p04 = 'p04',
  p05 = 'p05',
  Mul1X200 = 'Mul1X200',
  Mul2X100 = 'Mul2X100',
  Mul4X50 = 'Mul4X50',
  Mul8X25 = 'Mul8X25',
  Mul5X20 = 'Mul5X20',
  Mul2X50 = 'Mul2X50',
  Mul4X25 = 'Mul4X25',
  Mul5X200 = 'Mul5X200',
  Mul10X100 = 'Mul10X100',
  Mul20X50 = 'Mul20X50',
  Mul40X25 = 'Mul40X25',
  Mul25X200 = 'Mul25X200',
  Mul50X100 = 'Mul50X100',
  Mul100X50 = 'Mul100X50',
  Mul200X25 = 'Mul200X25',
  Mul10X200 = 'Mul10X200',
  Mul20X100 = 'Mul20X100',
  Mul40X50 = 'Mul40X50',
  Mul80X25 = 'Mul80X25',
  Mul50X20 = 'Mul50X20',
  Mul100X20 = 'Mul100X20',
  Mul10X20 = 'Mul10X20',
  mul1x200 = '1 x 200',
  mul2X100 = '2 x 100',
  mul4X50 = '4 x 50',
  mul8X25 = '8 x 25',
  mul5X20 = '5 x 20',
  mul2X50 = '2 x 50',
  mul4X25 = '4 x 25',
  mul5X200 = '5 x 200',
  mul10X100 = '10 x 100',
  mul20X50 = '20 x 50',
  mul40X25 = '40 x 25',
  mul25X200 = '25 x 200',
  mul50X100 = '50 x 100',
  mul100X50 = '100 x 50',
  mul200X25 = '200 x 25',
  mul10X200 = '10 x 200',
  mul20X100 = '20 x 100',
  mul40X50 = '40 x 50',
  mul80X25 = '80 x 25',
  mul50X20 = '50 x 20',
  mul100X20 = '100 x 20',
  mul10X20 = '10 x 20',
  LV01Val = '(LV01) U6-gRNA:ef1a-puro-2A-Cas9-2A-tGFP (Sigma all-in-one lentivirus)',
  LV02Val = '(LV02) U6-gRNA:ef1a-puro (GeCKOv2:puro lentivirus)',
  LV03Val = '(LV03) U6-gRNA:ef1a-tGFP (GeCKOv2:tGFP lentivirus)',
  LV04Val = '(LV04) U6-gRNA:hPGK-puro-2A-tBFP (Sanger lentivirus)',
  LV05Val = '(LV05) U6-gRNA:EF1a-Cas9+FLAG-2A-puro (GeCKOv2 all-in-one lentivirus)',
  LV08Val = '(LV08) U6-gRNA:EF1a-Puro (Optimized for gRNA expression)',
  LV13Val = '(LV13) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, stem-loop position)',
  LV14Val = "(LV14) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, 3' position)",
  LV15Val = '(LV15) U6-gRNA:EF1a-Puro-2a-BFP  (10x CS2, stem-loop position)',
  LV16Val = "(LV16) U6-gRNA:EF1a-Puro-2a-BFP  (10x CS2, 3' position)",
  LV17Val = '(LV17) U6-gRNA:EF1a-Puro-2a-BFP (Optimized gRNA scaffold with BFP)',
  TenPSixVal = '10^6 particles/ml',
  TenPSevenVal = '10^7 particles/ml',
  TenPEightVal = '10^8 particles/ml',
  TenPNineVal = '10^9 particles/ml',
  mul1x200Val = '1 x 200 μl',
  mul2X100Val = '2 x 100 μl',
  mul4X50Val = '4 x 50 μl',
  mul8X25Val = '8 x 25 μl',
  mul5X20Val = '5 x 20 μl',
  mul2X50Val = '2 x 50 μl',
  mul4X25Val = '4 x 25 μl',
  mul5X200Val = '5 x 200 μl',
  mul10X100Val = '10 x 100 μl',
  mul20X50Val = '20 x 50 μl',
  mul40X25Val = '40 x 25 μl',
  mul25X200Val = '25 x 200 μl',
  mul50X100Val = '50 x 100 μl',
  mul100X50Val = '100 x 50 μl',
  mul200X25Val = '200 x 25 μl',
  mul10X200Val = '10 x 200 μl',
  mul20X100Val = '20 x 100 μl',
  mul40X50Val = '40 x 50 μl',
  mul80X25Val = '80 x 25 μl',
  mul50X20Val = '50 x 20 μl',
  mul100X20Val = '100 x 20 μl',
  mul10X20Val = '10 x 20 μl',
  dotTwoVal = '200 μl',
  dotOneVal = '100 μl',
  oneVolVal = '1 ml',
  twoVolVal = '2 ml',
  fiveVolVal = '5 ml',
  RNAVal = 'Synthetic RNA',
  VIRUSVal = 'Lentivirus',
  DNAVal = 'Plasmid DNA',
  LV01Vec = '(LV01) U6-gRNA:ef1a-puro-2A-Cas9-2A-tGFP (Sigma all-in-one lentiviral plasmid)',
  LV02Vec = '(LV02) U6-gRNA:ef1a-puro (GeCKOv2:puro lentiviral plasmid)',
  LV03Vec = '(LV03) U6-gRNA:ef1a-tGFP (GeCKOv2:tGFP lentiviral plasmid)',
  LV04Vec = '(LV04) U6-gRNA:hPGK-puro-2A-tBFP (Sanger lentiviral plasmid)',
  LV05Vec = '(LV05) U6-gRNA:EF1a-Cas9+FLAG-2A-puro (GeCKOv2 all-in-one lentiviral plasmid)',
  LV08Vec = '(LV08) U6-gRNA:EF1a-Puro (Optimized for gRNA expression)',
  LV13Vec = '(LV13) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, stem-loop position)',
  LV14Vec = "(LV14) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, 3' position)",
  LV15Vec = '(LV15) U6-gRNA:EF1a-Puro-2a-BFP  (10x CS2, stem-loop position)',
  LV16Vec = "(LV16) U6-gRNA:EF1a-Puro-2a-BFP  (10x CS2, 3' position)",
  LV17Vec = '(LV17) U6-gRNA:EF1a-Puro-2a-BFP (Optimized gRNA scaffold with BFP)',
  p01Vec = '(p01) U6-gRNA:CMV-Cas9-2a-tGFP (transfection plasmid)',
  p02Vec = '(p02) U6-gRNA:CMV-Cas9-2A-tRFP (transfection plasmid)',
  p03Vec = '(p03) U6-gRNA (transfection plasmid)',
  p04Vec = '(p04) U6-gRNA:CMV-eCas9-2a-tGFP (transfection plasmid)',
  p05Vec = '(p05) U6-gRNA:CMV-eCas9-2a-tRFP (transfection plasmid)',
  oneVal = '1 μg',
  tenVal = '10 μg',
  TwentyFiveVal = '25 μg',
  hundredVal = '100 μg',
  YesVal = 'Yes',
  NoVal = 'No',
  DESALTVal = 'Desalt',
  ThreeVal = '3 nmol',
  TwoVal = '2 nmol',
  FiveVal = '5 nmol',
  SPCAS9Val = 'SpCas9',
  FNCAS9Val = 'FnCas9 (For noncellular, synthetic applications)',
  CRRNAVal = 'crRNA (tracrRNA sold separately)',
  SYGRNAVal = 'sgRNA (crRNA +tracrRNA as one)',
  quote = 'QUOTE',
  ZeroPrice = 0,
  All = 'All',
  Selected = 'Selected',
  Control = 'Control',
  Recommended = 'Recommended',
  microLtr = ' μl',
  noSelection = 'noSelection',
}

export enum PerPage {
  PerPage10 = '10',
  PerPage20 = '20',
  PerPage30 = '30',
  PerPage50 = '50',
  PerPage100 = '100',
  PerPageALL = 'All',
}

export enum SortBy {
  gRNAIDAsc = 'gRNA ID (Ascending)',
  gRNAIDDsc = 'gRNA ID (Descending)',
  GeneSymAsc = 'Gene Symbol (Ascending)',
  GeneSymDsc = 'Gene Symbol (Descending)',
  GeneIDAsc = 'Gene ID (Ascending)',
  GeneIDDsc = 'Gene ID (Descending)',
  gRNACategoryAsc = 'gRNA Category (Ascending)',
  gRNACategoryDsc = 'gRNA Category (Descending)',
  grnaId = 'grnaId',
  geneSymbol = 'geneSymbol',
  geneId = 'sortGeneId',
  gRNACategory = 'gRNACategory',
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum FileFormat {
  InvalidTemplate = 'INVALID_TEMPLATE',
  AcceptFormat = '.csv,.xls,.xlsx, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
  UploadTemplate = 'CRISPR_gRNA_Template',
  HeaderName = 'Enter Up To 100 Gene Symbols, Gene IDs, or MISSION™ gRNA IDs Below (1 per cell)',
}

export enum SemiConfigProperties {
  Quote = 'QUOTE',
  LoggedInUser = 'LoggedInUser',
  None = 'None',
  Continue = 'continue',
  AddOligo = 'addOligo',
  ErrorUrl = 'https://www.sigmaaldrich.com/webapp/wcs/stores/servlet/UserRegNavigation?storeId=11001',
  Success = 'success',
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
}
export enum Url {
  CrisprgrnaUrl = 'https://www.sigmaaldrich.com/technical-documents/articles/biology/crispr-clone-control-and-cas9-essentials.html#Cas9',
  SequenceUrl = '/semi-configurators/crisprgrna?activeLink=productSearch',
}

export enum DownloadOrderSummaryProps {
  ProductType = 'crisprgrna',
  FileName = 'OrderSummary_Crispr gRNA.xls',
}

export const EU_COUNTRY_CODES = [
  'ES',
  'PT',
  'SE',
  'DE',
  'GB',
  'FR',
  'BE',
  'IT',
  'NL',
  'CH',
  'AT',
  'CZ',
  'DK',
  'FI',
  'GR',
  'HU',
  'IE',
  'LU',
  'NQ',
  'PL',
]
export enum Species {
  Human = 'species:Human',
  Mouse = 'species:Mouse',
}
